import { makeAutoObservable } from 'mobx'

import { Feedback, Message, MessageError, MessageType } from '../types/thread'

class MessageModel {
   readonly messageId: number
   private _content: string
   readonly type: MessageType
   readonly timeStamp: Date
   private _feedback?: Feedback
   private _messageError?: MessageError

   private constructor(msg: Message) {
      this.messageId = msg.messageId
      this._content = msg.content
      this.type = msg.type
      this.timeStamp = msg.timeStamp
      this._feedback = msg.feedback

      makeAutoObservable(this, {}, { autoBind: true })
   }

   get content() {
      return this._content
   }

   get feedback() {
      return this._feedback
   }

   get messageError() {
      return this._messageError || ''
   }

   setContent(updatedContent: string) {
      this._content = updatedContent
   }

   setFeedback(updatedFeedback: Feedback) {
      this._feedback = updatedFeedback
   }

   setMessageError(messageError: MessageError) {
      this._messageError = messageError
   }

   static create(msg: Message): MessageModel {
      return new MessageModel(msg)
   }
}

export default MessageModel
